import { ApiResponse } from "../api/api";
import { ModalType } from "../config/ModalTypes";
import useModal from "./useModal";

const genericError = "An error occured.";

export default function useApi() {

  const showModal = useModal();

  return async<T = any>(apiCall: Promise<ApiResponse<T>>, showMessageOnSuccess: boolean = false, message: string = "Success!"): Promise<ApiResponse<T>> => {
    const result = await apiCall;

    if (!result) {
      showModal({
        text: genericError,
        type: ModalType.Error
      });

      return {
        success: false,
        canceled: false,
        message: genericError,
      }
    }

    switch (result.success) {
      case false:

        if (result?.canceled) {
          return {
            success: false,
            canceled: true,
            message: "Cancelled."
          }
        }

        showModal({
          text: result.message || message || genericError,
          type: ModalType.Error
        });

        return {
          success: false,
          canceled: false,
          message: result.message || genericError,
        }

      case true:

        if (showMessageOnSuccess) showModal({
          text: message,
          type: ModalType.Success
        });

        return result;
    }
  }
}